document.addEventListener('DOMContentLoaded', () => {
  const showTranscript = document.getElementById('show-transcript');
  if (showTranscript) {
    const theTranscript = document.getElementById('the-transcript');
    showTranscript.addEventListener('click', () => {
      theTranscript.style.display = 'block';
    });
  }

  const gifs = document.querySelectorAll('.client-video-gif');

  const gifsObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (entry.target.childElementCount === 0) {
          const src = entry.target.getAttribute('data-src');
          const preview = new Image();
          preview.src = src;
          preview.alt = 'Preview image';

          entry.target.appendChild(preview);
        }
      }
    });
  });

  [...gifs].forEach(gif => {
    gifsObserver.observe(gif);
  });

  resizePreviews();
  window.addEventListener('resize', resizePreviews);
});

function resizePreviews() {
  const previews = document.querySelectorAll('.client-video-preview');

  [...previews].forEach(preview => {
    preview.style.height = `${preview.clientWidth / 1.77}px`;
  });
}
